import React from 'react'

import { WALKTHROUGH_STEPS } from '@/components/flows/WalkthroughFlow/constants'
import { useWalkthroughSteps } from '@/components/flows/WalkthroughFlow/hooks/useWalkthroughSteps'
import { useIsMinWidthLg } from '@/hooks/useIsMinWidthLg'
import { THEME_PALETTE } from '@/lib/constants'
import { makeWidthAndHeight } from '@/lib/helpers/helperFunctions'
import { cn } from '@/lib/utils'

const StepList: React.FC = () => {
  const { currentStep } = useWalkthroughSteps()
  const isMinWidthLg = useIsMinWidthLg()

  const ICON_SIZE = {
    large: 36,
    medium: 32,
  }

  const steps: {
    label: string
    isActive: boolean
    icon: {
      url: string
      size: number
    }
  }[] = [
    {
      label: WALKTHROUGH_STEPS.introducingRq.label,
      isActive: currentStep.key === WALKTHROUGH_STEPS.introducingRq.key,
      icon: {
        url: WALKTHROUGH_STEPS.introducingRq.icon,
        size: ICON_SIZE.large,
      },
    },
    {
      label: WALKTHROUGH_STEPS.professionalNetwork1.label,
      isActive: [
        WALKTHROUGH_STEPS.professionalNetwork1.key,
        WALKTHROUGH_STEPS.professionalNetwork2.key,
        WALKTHROUGH_STEPS.professionalNetwork3.key,
      ].includes(currentStep.key),
      icon: {
        url: WALKTHROUGH_STEPS.professionalNetwork1.icon,
        size: ICON_SIZE.medium,
      },
    },
    {
      label: WALKTHROUGH_STEPS.referralEngine1.label,
      isActive: [
        WALKTHROUGH_STEPS.referralEngine1.key,
        WALKTHROUGH_STEPS.referralEngine2.key,
      ].includes(currentStep.key),
      icon: {
        url: WALKTHROUGH_STEPS.referralEngine1.icon,
        size: ICON_SIZE.large,
      },
    },
    {
      label: WALKTHROUGH_STEPS.compass.label,
      isActive: [WALKTHROUGH_STEPS.compass.key].includes(currentStep.key),
      icon: {
        url: WALKTHROUGH_STEPS.compass.icon,
        size: ICON_SIZE.large,
      },
    },
  ]

  return (
    <aside className="overflow-hidden rounded-md border border-b-0 bg-white">
      {steps.map((step) => (
        <div
          key={step.label}
          className={cn(
            'flex items-center gap-4 border-b',
            isMinWidthLg ? 'text-md' : 'text-body-base',
          )}
          style={{
            padding: isMinWidthLg ? '11px 16px' : '8px 12px',
            backgroundColor: step.isActive ? '#F6F6F6' : THEME_PALETTE.white,
          }}
        >
          <div
            className="flex items-center justify-center"
            style={{
              ...makeWidthAndHeight(isMinWidthLg ? ICON_SIZE.large + 2 : 22),
            }}
          >
            <img
              src={step.icon.url}
              alt={step.label}
              className="max-w-full"
              style={{
                ...makeWidthAndHeight(isMinWidthLg ? step.icon.size : 22),
              }}
            />
          </div>

          <div
            className={cn(
              {
                'font-medium text-black': step.isActive,
              },
              'font-light',
            )}
          >
            {step.label}
          </div>
        </div>
      ))}
    </aside>
  )
}

export default StepList
